import axios from 'axios';
import { MarketId } from 'types/market-id.enum';
import { ProfileType } from 'types/shared/profile-type.enum';
import { FeedStrategyProfile } from 'views/planning-prognosis/types/feed-strategy-profile.type';
import { PlanningPrognosisProfile } from 'views/planning-prognosis/types/planning-prognosis-profile.type';
import { ProfileAssortment } from 'views/planning-prognosis/types/profile-assortment.type';

// GET
// /ewosapi/v1/planandprognosis/profile/market/{marketId}/company/{globalCompanyId}/{profileType}/{includeLines}
export const getProfilesAssortment = async (marketId: MarketId, globalCompanyId: string): Promise<ProfileAssortment> => {
  const egiProfiles = await getPlanAndPrognosisProfiles(marketId, globalCompanyId, ProfileType.EGI);
  const efiProfiles = await getPlanAndPrognosisProfiles(marketId, globalCompanyId, ProfileType.EFI);
  const mortProfiles = await getPlanAndPrognosisProfiles(marketId, globalCompanyId, ProfileType.MORTALITY);
  const tempProfiles = await getPlanAndPrognosisProfiles(marketId, globalCompanyId, ProfileType.TEMPERATURE);
  const feedProfiles = await getPlanAndPrognosisFeedStrategies(marketId, globalCompanyId);

  return {
    egi: egiProfiles,
    efi: efiProfiles,
    mort: mortProfiles,
    feed: feedProfiles,
    temp: tempProfiles,
  };
};

export const getPlanAndPrognosisProfiles = async (
  marketId: MarketId,
  globalCompanyId: string,
  profileType: ProfileType,
  includeLines: boolean = false
): Promise<PlanningPrognosisProfile[]> => {
  const res = await axios.get<PlanningPrognosisProfile[]>(
    `/ewosapi/v1/planandprognosis/profile/market/${marketId}/company/${globalCompanyId}/${profileType}/${includeLines}?filter=all`
  );

  return res.data;
};

// GET
// /ewosapi/v1/planandprognosis/feedstrategy/market/{marketId}/company/{globalCompanyId}/{includeLines}
export const getPlanAndPrognosisFeedStrategies = async (
  marketId: MarketId,
  globalCompanyId: string,
  includeLines: boolean = false
): Promise<FeedStrategyProfile[]> => {
  const res = await axios.get<FeedStrategyProfile[]>(
    `/ewosapi/v1/planandprognosis/feedstrategy/market/${marketId}/company/${globalCompanyId}/${includeLines}?filter=all`
  );
  return res.data;
};
